export const ComponentsLoaderSymbol = Symbol('ComponentsLoader')
export const ComponentsRegistrarSymbol = Symbol('ComponentsRegistrar')
export const name = 'componentsLoader'
